import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var fileDownload = require("js-file-download");
import * as xlsx from "xlsx";
import axios from "axios";
import moment from "moment";
import { request } from "@/js/http/http_request.js";
import { isAdminNotConsultant } from "@/js/http/auth";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey, filterDecimal2digitsKeyAllowNegative } from "@/js/events/keycodes.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var cogsUpdateTypes = {
  LOWER: {
    id: "lower",
    name: "Lower available price"
  },
  AVERAGE: {
    id: "average",
    name: "Average price"
  }
};
function getYearsList() {
  var firstYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1900;
  var minusCurrentYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currentYear = new Date().getFullYear();
  var years = [];
  for (var year = firstYear; year <= currentYear - minusCurrentYear; year++) {
    years.push({
      id: year,
      name: year
    });
  }
  return years;
}
var defaultForm = {
  regionId: 4,
  producerIds: [],
  supplierIds: [],
  isUpdateCogs: true,
  updateCogsOptions: {
    isImmediate: true,
    scheduledDate: null,
    typeUpdate: cogsUpdateTypes.LOWER.id,
    typeAverageNbLower: null,
    modifierPercentage: -10,
    isPreventModificationWithConditionalDiscount: true,
    isPreventModificationWithWarehouseStock: true,
    preventModificationForWarehouseIds: [96, 102, 104, 105, 106, 107],
    preventModificationOnWineIds: []
  },
  isUpdateDirectProducerStockQuantities: true,
  updateDirectProducerStockQuantitiesOptions: {
    isPreventProductsDown: true,
    preventProductsDownOptions: {
      isMatchAllOptions: false,
      vintages: [1990, 1995, 1996, 2000, 2005, 2010, 2015],
      producerIds: [],
      productIds: []
    },
    isCloseDirectProducerStocksWithoutSupplierPrice: false,
    isDeactivateProductsWithoutSupplierPriceWithoutWarehouseStock: false
  },
  valid: false
};
export default {
  name: "ScriptWithSupplierPricesModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      dialog: false,
      isLoading: false,
      regionsList: [],
      producersList: [],
      suppliersList: [],
      warehousesList: [],
      winesList: [],
      vintagesList: getYearsList(),
      updateDateCogsMenu: null,
      minDate: moment().add(1, "days").toDate().formatForDatePickerDays(),
      runningScript: {
        form: _objectSpread({}, defaultForm),
        isPending: false,
        cancellationToken: null,
        result: null,
        headers: [{
          text: "Sku",
          value: "wine.sku",
          align: "center"
        }, {
          text: "Wine",
          value: "wine.name",
          align: "left"
        }, {
          text: "OldCogs",
          value: "oldCogs",
          align: "center"
        }, {
          text: "NewCogs",
          value: "newCogs",
          align: "center"
        }],
        headersStock: [{
          text: "Sku",
          value: "wine.sku",
          align: "center"
        }, {
          text: "Wine",
          value: "wine.name",
          align: "left"
        }, {
          text: "OldQuantity",
          value: "oldQuantity",
          align: "center"
        }, {
          text: "NewQuantity",
          value: "newQuantity",
          align: "center"
        }],
        headersWine: [{
          text: "Sku",
          value: "sku",
          align: "center"
        }, {
          text: "Wine",
          value: "name",
          align: "left"
        }],
        headersError: [{
          text: "Wine",
          value: "wine.name",
          align: "left"
        }, {
          text: "OldCogs",
          value: "oldCogs",
          align: "center"
        }, {
          text: "NewCogs",
          value: "newCogs",
          align: "center"
        }, {
          text: "Error",
          value: "error.message",
          align: "left"
        }],
        showResult: {
          cogsUpdateErrors: false,
          cogsUpdateds: false,
          cogsUpdateScheduleds: false,
          directStocksUpdated: false,
          directStocksClosed: false,
          directStocksCreated: false,
          winesDeactivated: false
        }
      },
      cogsUpdateTypes: cogsUpdateTypes,
      formRules: formRules,
      filterIntegerKey: filterIntegerKey,
      filterDecimal2digitsKeyAllowNegative: filterDecimal2digitsKeyAllowNegative,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isSomeOptionsLocked: function isSomeOptionsLocked() {
      return true;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isLoading || this.runningScript.isPending;
    },
    producerOfRegion: function producerOfRegion() {
      var _this$producersList;
      var regionId = this.runningScript.form.regionId;
      if (((_this$producersList = this.producersList) === null || _this$producersList === void 0 ? void 0 : _this$producersList.length) > 0 && regionId > 0) {
        return this.producersList.filter(function (producer) {
          var parentRegionIds = producer.regionSubs.map(function (rsub) {
            return rsub.regionParent.id;
          });
          return parentRegionIds.some(function (id) {
            return id == regionId;
          });
        });
      }
      return [];
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this = _this2;
            _this2.isLoading = true;
            Promise.all([_this2.getRegions(), _this2.getProducers(), _this2.getSuppliers(), _this2.getWarehouses(), _this2.getWines()]).finally(function () {
              _this.isLoading = false;
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    confirmRunScript: function confirmRunScript() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.$refs.confirm.open("Executes configured updates", "Are you sure to execute all configured updates ? Warning: This action cannot be undone.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(confirm) {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!confirm) {
                          _context2.next = 3;
                          break;
                        }
                        _context2.next = 3;
                        return _this3.runScript();
                      case 3:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    runScript: function runScript() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this$runningScript$c;
        var _this, _this4$runningScript$, valid, withoutValid, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this4.runningScript.isPending = true;
              _this4.runningScript.result = null;
              _this = _this4;
              (_this$runningScript$c = _this.runningScript.cancellationToken) === null || _this$runningScript$c === void 0 || _this$runningScript$c.cancel();
              _this.runningScript.cancellationToken = axios.CancelToken.source();
              _this4$runningScript$ = _this4.runningScript.form, valid = _this4$runningScript$.valid, withoutValid = _objectWithoutProperties(_this4$runningScript$, _excluded);
              _context5.next = 8;
              return request("/v1/suppliers/scripts/cogs-and-stocks-updates", "put", withoutValid, true, "api", null, _this.runningScript.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          errorData = getErrorData(e, {}, "Unable to execute updates.", true);
                          handleErrorData(_this, errorData);
                        }
                        _this.runningScript.isPending = false;
                        throw e;
                      case 3:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 8:
              response = _context5.sent;
              _this4.runningScript.isPending = false;
              _this4.runningScript.result = _objectSpread({}, response.data.value);
              _this4.$emit("scriptExecuted");
              _this4.$toasted.show("Updates executed", {
                type: "success"
              });
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    cancelRunningScript: function cancelRunningScript() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this5$runningScript$;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              (_this5$runningScript$ = _this5.runningScript.cancellationToken) === null || _this5$runningScript$ === void 0 || _this5$runningScript$.cancel();
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    changeRegions: function changeRegions() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this6.$nextTick(function () {
                var producerIdsAllowed = _this6.producerOfRegion.map(function (x) {
                  return x.id;
                });
                _this6.runningScript.form.producerIds = _this6.runningScript.form.producerIds.filter(function (x) {
                  return producerIdsAllowed.includes(x);
                });
                _this6.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions.producerIds = _this6.runningScript.form.updateDirectProducerStockQuantitiesOptions.preventProductsDownOptions.producerIds.filter(function (x) {
                  return producerIdsAllowed.includes(x);
                });
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getRegions: function getRegions() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this = _this7;
              _context8.next = 3;
              return request("/v1/regions", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load regions list");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context8.sent;
              if (response.data !== null) {
                _this7.regionsList = _toConsumableArray(response.data);
              }
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getProducers: function getProducers() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this = _this8;
              _context9.next = 3;
              return request("/v1/producers/all", "post", {
                isWinery: true
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load producers.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context9.sent;
              _this8.producersList = _toConsumableArray(response.data.value.items);
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    getSuppliers: function getSuppliers() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this = _this9;
              _context10.next = 3;
              return request("/v1/suppliers", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load suppliers.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context10.sent;
              if (response) {
                _this9.suppliersList = response.data.value.sort(function (a, b) {
                  if (a.producerId === null !== (b.producerId === null)) {
                    return a.producerId === null ? -1 : 1;
                  }
                  return a.name.localeCompare(b.name);
                }).map(function (supplier) {
                  return _objectSpread(_objectSpread({}, supplier), {}, {
                    display_name: "".concat(supplier.name, " (").concat(supplier.producerId ? "producer" : "supplier", ")")
                  });
                });
              }
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    getWarehouses: function getWarehouses() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this, response, usaWarehouseIds;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this = _this10;
              _context11.next = 3;
              return request("/v1/warehouses", "post", {
                paging: null
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context11.sent;
              _this10.warehousesList = _toConsumableArray(response.data.warehouses);
              usaWarehouseIds = _this10.warehousesList.filter(function (x) {
                return x.address.country.iso_2 == "US";
              }).map(function (x) {
                return x.id_warehouse;
              });
              _this10.runningScript.form.updateCogsOptions.preventModificationForWarehouseIds = _toConsumableArray(usaWarehouseIds);
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    getWines: function getWines() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this = _this11;
              _context12.next = 3;
              return request("/v1/wines", "post", {
                paging: null,
                calculate_prices: false,
                only_display_names: true,
                bypassStockSeek: true,
                byPassPagingLimitation: true
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context12.sent;
              _this11.winesList = _toConsumableArray(response.data.wines.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  display_name: x.display_name + (x.accountancy_code ? " - " + x.accountancy_code : "")
                });
              }));
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    open: function open() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this12.resetData();
              _this12.dialog = true;
              return _context13.abrupt("return", new Promise(function (resolve, reject) {
                _this12.resolve = resolve;
                _this12.reject = reject;
              }));
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      //not needed, at any dialog close, the component is destroyed
      this.photo = null;
      this.isLoading = false;
    },
    ExportResults: function ExportResults() {
      var formattedDate = moment().format("YYYY-MM-DD");
      var fileName = "UPDATE_SUPPLIER_PRICES_RESULTS-".concat(formattedDate, ".xlsx");
      var cogsCount = this.runningScript.result.cogsUpdateds.length;
      var stockUpdatedCount = this.runningScript.result.directStocksUpdated.length;
      var stockCreatedCount = this.runningScript.result.directStocksCreated.length;
      var stockClosedCount = this.runningScript.result.directStocksClosed.length;
      var wineDeactivatedCount = this.runningScript.result.winesDeactivated.length;
      var errorsCount = this.runningScript.result.cogsUpdateErrors.length;
      var ensureHeaders = function ensureHeaders(data, headers) {
        if (data.length === 0) {
          var emptyRow = {};
          headers.forEach(function (h) {
            return emptyRow[h] = "";
          });
          return [emptyRow];
        }
        return data;
      };
      var dataCogs = ensureHeaders(this.runningScript.result.cogsUpdateds.map(function (item) {
        var _item$wine, _item$wine2, _item$oldCogs, _item$newCogs;
        return {
          Sku: ((_item$wine = item.wine) === null || _item$wine === void 0 ? void 0 : _item$wine.sku) || "",
          Wine: ((_item$wine2 = item.wine) === null || _item$wine2 === void 0 ? void 0 : _item$wine2.name) || "",
          OldCogs: (_item$oldCogs = item.oldCogs) !== null && _item$oldCogs !== void 0 ? _item$oldCogs : "",
          NewCogs: (_item$newCogs = item.newCogs) !== null && _item$newCogs !== void 0 ? _item$newCogs : ""
        };
      }), ["Sku", "Wine", "OldCogs", "NewCogs"]);
      var worksheetCogs = xlsx.utils.json_to_sheet(dataCogs);
      var dataStockUpdated = ensureHeaders(this.runningScript.result.directStocksUpdated.map(function (item) {
        var _item$wine3, _item$wine4, _item$oldQuantity, _item$newQuantity;
        return {
          Sku: ((_item$wine3 = item.wine) === null || _item$wine3 === void 0 ? void 0 : _item$wine3.sku) || "",
          Wine: ((_item$wine4 = item.wine) === null || _item$wine4 === void 0 ? void 0 : _item$wine4.name) || "",
          OldQuantity: (_item$oldQuantity = item.oldQuantity) !== null && _item$oldQuantity !== void 0 ? _item$oldQuantity : "",
          NewQuantity: (_item$newQuantity = item.newQuantity) !== null && _item$newQuantity !== void 0 ? _item$newQuantity : ""
        };
      }), ["Sku", "Wine", "OldQuantity", "NewQuantity"]);
      var worksheetStockUpdated = xlsx.utils.json_to_sheet(dataStockUpdated);
      var dataStockCreated = ensureHeaders(this.runningScript.result.directStocksCreated.map(function (item) {
        var _item$wine5, _item$wine6, _item$oldQuantity2, _item$newQuantity2;
        return {
          Sku: ((_item$wine5 = item.wine) === null || _item$wine5 === void 0 ? void 0 : _item$wine5.sku) || "",
          Wine: ((_item$wine6 = item.wine) === null || _item$wine6 === void 0 ? void 0 : _item$wine6.name) || "",
          OldQuantity: (_item$oldQuantity2 = item.oldQuantity) !== null && _item$oldQuantity2 !== void 0 ? _item$oldQuantity2 : "",
          NewQuantity: (_item$newQuantity2 = item.newQuantity) !== null && _item$newQuantity2 !== void 0 ? _item$newQuantity2 : ""
        };
      }), ["Sku", "Wine", "OldQuantity", "NewQuantity"]);
      var worksheetStockCreated = xlsx.utils.json_to_sheet(dataStockCreated);
      var dataStockClosed = ensureHeaders(this.runningScript.result.directStocksClosed.map(function (item) {
        var _item$wine7, _item$wine8, _item$oldQuantity3, _item$newQuantity3;
        return {
          Sku: ((_item$wine7 = item.wine) === null || _item$wine7 === void 0 ? void 0 : _item$wine7.sku) || "",
          Wine: ((_item$wine8 = item.wine) === null || _item$wine8 === void 0 ? void 0 : _item$wine8.name) || "",
          OldQuantity: (_item$oldQuantity3 = item.oldQuantity) !== null && _item$oldQuantity3 !== void 0 ? _item$oldQuantity3 : "",
          NewQuantity: (_item$newQuantity3 = item.newQuantity) !== null && _item$newQuantity3 !== void 0 ? _item$newQuantity3 : ""
        };
      }), ["Sku", "Wine", "OldQuantity", "NewQuantity"]);
      var worksheetStockClosed = xlsx.utils.json_to_sheet(dataStockClosed);
      var dataWineDeactivated = ensureHeaders(this.runningScript.result.winesDeactivated.map(function (item) {
        var _item$wine9, _item$wine10;
        return {
          Sku: ((_item$wine9 = item.wine) === null || _item$wine9 === void 0 ? void 0 : _item$wine9.sku) || "",
          Wine: ((_item$wine10 = item.wine) === null || _item$wine10 === void 0 ? void 0 : _item$wine10.name) || ""
        };
      }), ["Sku", "Wine"]);
      var worksheetWineDeactivated = xlsx.utils.json_to_sheet(dataWineDeactivated);
      var dataErrors = ensureHeaders(this.runningScript.result.cogsUpdateErrors.map(function (item) {
        var _item$wine11, _item$oldCogs2, _item$newCogs2, _item$error;
        return {
          Wine: ((_item$wine11 = item.wine) === null || _item$wine11 === void 0 ? void 0 : _item$wine11.name) || "",
          OldCogs: (_item$oldCogs2 = item.oldCogs) !== null && _item$oldCogs2 !== void 0 ? _item$oldCogs2 : "",
          NewCogs: (_item$newCogs2 = item.newCogs) !== null && _item$newCogs2 !== void 0 ? _item$newCogs2 : "",
          Error: ((_item$error = item.error) === null || _item$error === void 0 ? void 0 : _item$error.message) || ""
        };
      }), ["Wine", "OldCogs", "NewCogs", "Error"]);
      var worksheetErrors = xlsx.utils.json_to_sheet(dataErrors);
      var workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheetCogs, "Cogs updated(".concat(cogsCount, ")"));
      xlsx.utils.book_append_sheet(workbook, worksheetStockUpdated, "Stocks Updated(".concat(stockUpdatedCount, ")"));
      xlsx.utils.book_append_sheet(workbook, worksheetStockCreated, "Stocks Created(".concat(stockCreatedCount, ")"));
      xlsx.utils.book_append_sheet(workbook, worksheetStockClosed, "Stocks Closed(".concat(stockClosedCount, ")"));
      xlsx.utils.book_append_sheet(workbook, worksheetWineDeactivated, "Wine deactivated(".concat(wineDeactivatedCount, ")"));
      xlsx.utils.book_append_sheet(workbook, worksheetErrors, "Errors(".concat(errorsCount, ")"));
      var excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      var dataBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      fileDownload(dataBlob, fileName, "application/xlsx");
    },
    filterVAutocomplete: filterVAutocomplete,
    isAdminNotConsultant: isAdminNotConsultant
  }
};